export default "__VITE_ASSET___I67dBAz__"